export interface PersonalData {
  name: string;
  profile: string;
  designation: string;
  descriptionShort: string;
  description: string;
  email: string;
  phone: string;
  address: string;
  github: string;
  facebook: string;
  linkedIn: string;
  x: string;
  stackOverflow: string;
  instagram: string;
  devUsername: string;
  resume: string;
}

export const personalData: PersonalData = {
  name: 'Gustavo Decker',
  profile: '/profile-pic-full.png',
  designation: 'Senior Backend Software Engineer',
  description:
    'Senior Backend Engineer with 10+ years of experience architecting scalable serverless solutions on AWS. I help US-based startups build resilient, cost-effective systems using Node.js and TypeScript. Expert in migrating legacy monoliths to modern microservices without business disruption.',
  descriptionShort:
    'Senior Backend Engineer specializing in AWS Serverless, Node.js, and TypeScript. Delivering scalable cloud architectures for US/EU startups from EST timezone.',
  email: 'gustavdz@gmail.com',
  phone: '+593 98 838 9345',
  address: 'Guayaquil, Ecuador',
  github: 'https://github.com/gustavdz',
  facebook: 'https://www.facebook.com/gustavo.decker',
  linkedIn: 'https://www.linkedin.com/in/gustavodeckerz/',
  x: 'https://x.com/gustavdz',
  stackOverflow: 'https://stackoverflow.com/users/12719027/gustavo-decker',
  instagram: 'https://instagram.com/gustavodeckerz',
  devUsername: 'gustavdz',
  resume: '/gustavo-decker-resume.pdf',
};
